if (!customElements.get('anirona-account-menu')) {
  customElements.define(
    'anirona-account-menu',
    class AnironaAccountMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-anirona-account-trigger]');
        this.menu = this.querySelector('[data-anirona-account-panel]');
        if (!this.trigger || !this.menu) return;

        this.desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        this.openDelay = 120;
        this.closeDelay = 220;
        this.handlePointerEnter = () => this.scheduleOpen();
        this.handlePointerLeave = () => this.scheduleClose();
        this.handleFocusIn = (event) => {
          if (this.suppressTriggerFocus && event.composedPath().includes(this.trigger)) return;
          this.open();
        };
        this.handleFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.scheduleClose(0);
        };
        this.handleKeydown = (event) => {
          if (event.key !== 'Escape' || !this.isOpen()) return;
          event.preventDefault();
          this.close();
          this.trigger.focus?.();
        };
        this.handleDocumentClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };
        this.handleTriggerPointerDown = () => {
          this.suppressTriggerFocus = true;
          window.clearTimeout(this.focusSuppressTimer);
        };
        this.handleTriggerPointerUp = () => {
          this.close();
          this.focusSuppressTimer = window.setTimeout(() => {
            this.suppressTriggerFocus = false;
          }, 350);
        };
        this.handleTriggerPointerCancel = () => {
          this.suppressTriggerFocus = false;
          window.clearTimeout(this.focusSuppressTimer);
        };
        this.handleTriggerClick = (event) => {
          if (event.composedPath().includes(this.trigger)) this.close();
        };
        this.handleMediaChange = () => {
          if (!this.desktopQuery.matches) this.close();
        };

        this.addEventListener('pointerenter', this.handlePointerEnter);
        this.addEventListener('pointerleave', this.handlePointerLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        this.addEventListener('click', this.handleTriggerClick);
        this.trigger.addEventListener('pointerdown', this.handleTriggerPointerDown);
        this.trigger.addEventListener('pointerup', this.handleTriggerPointerUp);
        this.trigger.addEventListener('pointercancel', this.handleTriggerPointerCancel);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        this.desktopQuery.addEventListener('change', this.handleMediaChange);
      }

      disconnectedCallback() {
        this.clearTimers();
        window.clearTimeout(this.focusSuppressTimer);
        this.removeEventListener('pointerenter', this.handlePointerEnter);
        this.removeEventListener('pointerleave', this.handlePointerLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.removeEventListener('click', this.handleTriggerClick);
        this.trigger?.removeEventListener('pointerdown', this.handleTriggerPointerDown);
        this.trigger?.removeEventListener('pointerup', this.handleTriggerPointerUp);
        this.trigger?.removeEventListener('pointercancel', this.handleTriggerPointerCancel);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        this.desktopQuery?.removeEventListener('change', this.handleMediaChange);
      }

      clearTimers() {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
      }

      scheduleOpen() {
        if (!this.desktopQuery.matches) return;
        window.clearTimeout(this.closeTimer);
        window.clearTimeout(this.openTimer);
        this.openTimer = window.setTimeout(() => this.open(), this.openDelay);
      }

      scheduleClose(delay = this.closeDelay) {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => this.close(), delay);
      }

      isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      open() {
        if (!this.desktopQuery.matches) return;
        this.clearTimers();
        this.menu.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.setAttribute('open', '');
      }

      close() {
        this.clearTimers();
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.removeAttribute('open');
      }
    }
  );
}
